import React from 'react';
import { Tag, Tooltip } from 'antd';
import styled from 'styled-components';

import StructuredPropertyValue from './StructuredPropertyValue';
import { PropertyRow } from './types';

import { StdDataType, PropertyCardinality } from '../../../../../types.generated';

interface Props {
    propertyRow: PropertyRow;
    filterText?: string;
}

const StyledTag = styled(Tag)`
    span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block !important;
    }
`;

export default function ValuesColumn({ propertyRow, filterText }: Props) {
    const { values, displayName, isEditable, structuredProperty } = propertyRow;
    const isRichText = propertyRow.dataType?.info.type === StdDataType.RichText;

    const isCardinalityMultiple = structuredProperty?.definition?.cardinality === PropertyCardinality.Multiple;
    const isTypeString = structuredProperty?.definition?.valueType?.info.type === StdDataType.String;

    const renderValues = () => {
        if (isCardinalityMultiple && isTypeString && values?.length) {
            const count = (values?.length || 0) - 1;
            const value = values?.[0].value || '-';

            return (
                <div className="f-tag-container">
                    <StyledTag className="label-tag grey-tag-light ma-0">
                        <span>{value}</span>
                    </StyledTag>
                    {count > 0 && (
                        <Tooltip
                            placement="bottom"
                            title={
                                <div>
                                    {values.slice(1).map((v) => (
                                        <div key={v.value}>{v.value || '&ndash;'}</div>
                                    ))}
                                </div>
                            }
                        >
                            <Tag className="base-tag label-tag ma-0">+{count}</Tag>
                        </Tooltip>
                    )}
                </div>
            );
        }

        if (values?.length) {
            return values.map((v) => (
                <StructuredPropertyValue
                    value={v}
                    isRichText={isRichText}
                    filterText={filterText}
                    displayName={displayName}
                    isEditable={isEditable}
                />
            ));
        }

        return <span>&ndash;</span>;
    };

    return <>{renderValues()}</>;
}
